module.exports = __webpack_public_path__ + "static/img/Aacteacher4.ede2e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aacteacher4.png
// module id = tj6M
// module chunks = 1